module.exports = __webpack_public_path__ + "media/images/grid-936185c9f98e0f6fc269a3dbb2fb9e4e.svg";